import * as React from 'react'

import { Icon, IconProps } from './Icon'

export const CheckSolidGreyIcon: React.FC<IconProps> = props => (
  <Icon viewBox="0 0 18 13" fill="currentColor" {...props}>
    <path d="M6.55001 13L0.850006 7.29998L2.27501 5.87498L6.55001 10.15L15.725 0.974976L17.15 2.39998L6.55001 13Z" />
  </Icon>
)
